export const convertLocaleToCultureHeader = (locale: string): string => {
  switch (locale) {
    case 'it':
      return 'it-IT'
    case 'en':
      return 'en-GB'
    case 'de':
      return 'de-DE'
    case 'fr':
      return 'fr-FR'
    case 'es':
      return 'es-ES'
    case 'pt':
      return 'pt-PT'
  }
  return locale
}
